import { graphql } from 'gatsby';
import React from 'react';

interface StrengthsProps {
  strengths: Strength[];
}

interface Strength {
  image_field: {
    src: string;
    alt: string;
  };
  title: string;
  cta: {
    link: string;
    text: string;
  };
}

const Strengths: React.FC<StrengthsProps> = ({ strengths }) => {
  return (
    <div className='block__strengths'>
      {strengths.map(({cta, title, image_field: image}, index) => (
        <a key={index} className='strengths__item' href={cta.link}>
          <img
            className='strengths__image'
            src={image.src}
            alt={image.alt}
          />
          <h3 className='strengths__title' dangerouslySetInnerHTML={{__html: title }}/>
          <div className='strengths__cta'>
            {cta.text && <span className='strengths__cta-text'>{cta.text}</span>}
            <span className='strengths__cta-icon'>→</span>
          </div>
        </a>
      ))}
    </div>
  );
};

export default Strengths;

export const strengthsFragmentQuery = graphql`
  fragment StrengthsFragment on Block {
    strengths {
      image_field {
        ...ImageFieldFragment
      }
      title
      cta {
        link
        text
      }
    }
  }
`;